
        <ng-container *ngIf="dialog.state$ | async as state">
<div
  class="external-viewer-backdrop fixed inset-0 z-[2147483647] flex items-end justify-center bg-black/60 px-2 pt-[calc(max(0.5rem,env(safe-area-inset-top))+var(--mobile-header-h,0px))] pb-[calc(0.5rem+env(safe-area-inset-bottom))] sm:items-center sm:px-4 sm:py-4"
                (click)="close()"
            >
                <div
                    class="external-viewer-panel relative flex h-[calc(100dvh-var(--mobile-header-h,0px)-1rem-env(safe-area-inset-top)-env(safe-area-inset-bottom))] max-h-[calc(100dvh-var(--mobile-header-h,0px)-1rem-env(safe-area-inset-top)-env(safe-area-inset-bottom))] w-full max-w-[97vw] xl:max-w-[92vw] 2xl:max-w-[1600px] flex-col overflow-hidden rounded-3xl border border-[color:var(--border)] bg-[color:var(--card)] shadow-2xl sm:h-[calc(100dvh-var(--mobile-header-h,0px)-2rem)] sm:max-h-[calc(100dvh-var(--mobile-header-h,0px)-2rem)]"
                    (click)="$event.stopPropagation()"
                    role="dialog"
                    aria-modal="true">

                    <ng-container *ngIf="viewerComponent; else loadingTpl">
                        <ng-container
                            *ngComponentOutlet="viewerComponent; inputs: { title: state.title, fileId: state.fileId, privateFileId: state.privateFileId, src: state.src, reservationId: state.reservationId, paymentPlanId: state.paymentPlanId, projectId: state.projectId, mode: 'dialog' }"
                        ></ng-container>
                    </ng-container>

                    <ng-template #loadingTpl>
                        <div class="flex h-full flex-col items-center justify-center gap-3 p-6 text-sm text-[color:var(--muted-foreground)]">
                            <ng-container *ngIf="loadError; else loadingState">
                                <p class="text-red-600">{{ loadError }}</p>
                                <button
                                    type="button"
                                    class="inline-flex items-center gap-2 rounded-lg border border-[color:var(--border)] bg-[color:var(--card)] px-3 py-2 text-sm font-semibold text-[color:var(--foreground)] transition hover:bg-[color:var(--hover)]"
                                    (click)="retryLoad()"
                                >
                                    <lucide-icon name="refresh-cw" class="h-4 w-4"></lucide-icon>
                                    Retry
                                </button>
                            </ng-container>
                            <ng-template #loadingState>
                                <div class="flex items-center gap-2">
                                    <lucide-icon name="loader-2" class="h-5 w-5 animate-spin"></lucide-icon>
                                    Opening…
                                </div>
                            </ng-template>
                        </div>
                    </ng-template>
                </div>
            </div>
        </ng-container>
    
